// extracted by mini-css-extract-plugin
module.exports = {"submit":"Form-module__submit___2EarQ","message":"Form-module__message___3LEA1","error":"Form-module__error___30u_J","success":"Form-module__success___2ZpDL"};